import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Link } from "react-router-dom";
import TruncateText from "../../components/common/TruncateText";
import { viewPath } from "../../utils/routeUtils";

const PREFIX = "ConfigTable";

const classes = {
  root: `${PREFIX}-root`,
  root2: `${PREFIX}-root2`,
  table: `${PREFIX}-table`,
  tableCell: `${PREFIX}-tableCell`,
};

const StyledPaper = styled(Paper)({
  [`& .${classes.root2}`]: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  [`& .${classes.table}`]: {
    tableLayout: "fixed",
    wordWrap: "break-word",
  },
  [`& .${classes.tableCell}`]: {
    borderBottom: "none",
  },
});

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export interface ConfigTableProps {
  solution_page: boolean;
  readonly config?:
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        readonly created: any | null | undefined;
        readonly id: string;
        readonly source_models:
          | ReadonlyArray<
              | {
                  readonly __typename?: string;
                  readonly file_name?: string | null | undefined;
                  readonly file_url?: string | null | undefined;
                  readonly id?: string;
                  readonly meta?:
                    | ReadonlyArray<
                        | {
                            readonly k: string | null | undefined;
                            readonly v: string | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        readonly template_archive:
          | {
              readonly file_name: string | null | undefined;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              readonly file_size: any | null | undefined;
              readonly file_url: string | null | undefined;
              readonly md5_digest: string | null | undefined;
              readonly meta:
                | ReadonlyArray<
                    | {
                        readonly k: string | null | undefined;
                        readonly v: string | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
}

const ConfigTable: React.FC<ConfigTableProps> = ({ config }) => {
  return (
    <>
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        <strong>WARNING: </strong> Source Models are not expected to be correct after 17/12/2023
      </div>

      <StyledPaper className={classes.root}>
        <Table stickyHeader size="small" className={classes.table}>
          <colgroup>
            <col style={{ width: "50%" }} />
          </colgroup>
          <TableHead>
            <AlternatingRow
              classes={{
                root: classes.root,
              }}
            >
              <TableCell colSpan={3}>Source Models</TableCell>
            </AlternatingRow>
          </TableHead>
          <TableBody>
            {config?.source_models?.map((source_model) => (
              <AlternatingRow key={Math.random()} classes={{ root: classes.root }}>
                <TableCell>
                  <TruncateText text={source_model?.file_name ?? ""} />
                </TableCell>
                <TableCell>
                  <Button variant="outlined" href={source_model?.file_url ?? ""}>
                    Download
                  </Button>
                </TableCell>
                <TableCell>
                  <Button component={Link} variant="outlined" to={viewPath(source_model?.id)}>
                    more
                  </Button>
                </TableCell>
              </AlternatingRow>
            ))}
          </TableBody>
        </Table>
      </StyledPaper>
    </>
  );
};

export default ConfigTable;
